import PageHeader from '../Components/PageHeader';
import ContactBand from '../Components/ContactBand';
import { products, values } from '../data/site';

const ReadMore = () => (
  <>
    <PageHeader eyebrow="Company" title="About Sneh Communications" />

    <section className="section">
      <div className="container split">
        <div>
          <p className="eyebrow">Who we are</p>
          <h2>A healthcare supply partner for Northern India</h2>
        </div>
        <div>
          <p className="lead">
            Sneh Communications has been providing medical equipment, diagnostic kits, radiology
            equipment, and blood bank related products and services to private and government
            hospitals and diagnostic centres around the states of Northern India.
          </p>
          <ul className="check-list">
            {products.map((product) => <li key={product.title}>{product.title}</li>)}
          </ul>
        </div>
      </div>
    </section>

    <section className="vision">
      <div className="container">
        <p className="eyebrow eyebrow--light">Our vision</p>
        <blockquote>
          Reaching people and touching lives globally as a leading provider of valued medicines.
        </blockquote>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">Our values</p>
          <h2>Our values represent our promise to our stakeholders</h2>
        </div>
        <div className="card-grid card-grid--four">
          {values.map((value) => (
            <article key={value.title} className="card">
              <h3>{value.title}</h3>
              <p>{value.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <ContactBand />
  </>
);

export default ReadMore;
